var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteEnvironment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "streamline:natrue-ecology-recycle-1-sign-environment-protect-save-arrows",
    clipPath: "url(#clip0_3082_5903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.0713 35.486V42.3432C21.0624 42.6009 20.9537 42.8451 20.7682 43.0242C20.5827 43.2033 20.3349 43.3033 20.077 43.3032H12.877C11.6932 43.1037 10.6215 42.4826 9.85986 41.5546",
    stroke: "white",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.9858 22.766L41.0601 19.3375C41.1735 19.2874 41.2961 19.2615 41.4201 19.2615C41.544 19.2615 41.6667 19.2874 41.7801 19.3375C41.9125 19.353 42.0398 19.398 42.1525 19.4692C42.2653 19.5404 42.3606 19.636 42.4315 19.7489L46.3744 25.646C46.6099 26.1201 46.7325 26.6423 46.7325 27.1717C46.7325 27.7012 46.6099 28.2234 46.3744 28.6975M9.86007 41.5889C9.86007 41.5889 6.12293 38.3317 14.7972 29.6575H18.6715L12.8772 20.0917H2.21436L5.12864 23.8289C5.12864 23.8289 3.17436 24.1717 3.17436 26.8803C4.1994 32.2458 6.49162 37.2886 9.86007 41.5889Z",
    stroke: "white",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.4145 15.6003L10.7859 13.4746C10.5576 13.3567 10.3817 13.1575 10.2929 12.9164C10.2041 12.6753 10.2087 12.4096 10.3059 12.1718L14.2145 4.35462C14.4756 3.8918 14.8407 3.49602 15.281 3.19851C15.7214 2.901 16.2248 2.70991 16.7516 2.64033M16.7516 2.64033C16.7516 2.64033 20.9688 2.64033 26.3173 12.926L23.5402 16.3546H35.0602L39.1402 5.5889L34.3402 7.06319C34.2704 6.31928 34.001 5.60802 33.5605 5.00454C33.12 4.40106 32.5246 3.92775 31.8373 3.63462C29.4742 2.85228 26.9864 2.51515 24.5002 2.64033H16.7516ZM46.5116 28.3546C46.5116 28.3546 45.4145 32.8118 34.0659 31.7832V28.8003L27.4145 37.5089L33.7231 47.2118L34.0659 42.6518C34.0659 42.6518 35.3345 44.1946 37.4945 42.6518C41.117 38.3042 44.149 33.4968 46.5116 28.3546Z",
    stroke: "white",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3082_5903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.926025)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEnvironment);
export default __webpack_public_path__ + "static/media/whiteEnvironment.a94675ab0306b3e1bcd0fd7bf507ad21.svg";
export { ForwardRef as ReactComponent };